module.exports = __webpack_public_path__ + "assets/images/thumbs/gallery_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/thumbs/gallery_2x.jpg
// module id = 822
// module chunks = 0